<!-- src/components/LichSuGiaoNhan.vue -->
<template>
  <div class="card shadow-sm">
    <div class="card-header font-weight-bold">
      <i class="fa fa-clock mr-2"></i>Lịch sử nhận / trả xe
    </div>

    <div class="card-body p-2">
      <div v-if="isLoading" class="text-center py-3">
        <i class="fa fa-spinner fa-spin"></i> Đang tải...
      </div>
      <div v-else-if="error" class="alert alert-danger py-2">{{ error }}</div>
      <div v-else-if="logs.length === 0" class="text-muted small px-2 py-2">
        Chưa có lịch sử.
      </div>
      <ul v-else class="list-group list-group-flush">
        <li v-for="e in logs" :key="e.id" class="list-group-item d-flex align-items-center">
          <span class="badge mr-2" :class="e.eventType==='RECEIVE' ? 'badge-primary' : 'badge-success'">
            {{ e.eventType==='RECEIVE' ? 'Nhận' : 'Trả' }}
          </span>
          <div class="flex-grow-1">
            <div class="font-weight-600">
              {{ formatTs(e.eventTime) }}
            </div>
            <div class="small text-muted">
              ODO: {{ e.odo ?? '—' }}
              <span v-if="e.eventType==='RETURN'"> • Nhiên liệu: {{ e.mucNhienLieu ?? '—' }}%</span>
              <span v-if="e.ghiChu"> • {{ e.ghiChu }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { XePhanCongApi } from '@/services/xePhanCongService';

export default {
  name: "LichSuGiaoNhan",
  props: {
    phanCongId: { type: [Number, String], default: null } // nếu truyền thì gọi theo pc, còn không thì gọi /me
  },
  data() {
    return { logs: [], isLoading: false, error: null };
  },
  methods: {
    async load() {
      this.isLoading = true; this.error = null;
      try {
        this.logs = this.phanCongId
          ? await XePhanCongApi.byPhanCong(this.phanCongId)
          : await XePhanCongApi.myCurrent();
      } catch (e) {
        this.error = e?.response?.data?.message || e?.message || "Lỗi tải lịch sử";
      } finally { this.isLoading = false; }
    },
    formatTs(ts) {
      if (!ts) return "—";
      const d = new Date(ts);
      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const yyyy = d.getFullYear();
      const hh = String(d.getHours()).padStart(2, "0");
      const mi = String(d.getMinutes()).padStart(2, "0");
      return `${dd}/${mm}/${yyyy} ${hh}:${mi}`;
    }
  },
  mounted() { this.load(); },
  watch: { phanCongId() { this.load(); } }
};
</script>

<style scoped>
.font-weight-600 { font-weight:600; }
.badge { font-size: 12px; }
</style>
